import Manager from '../image-manager/manager'

export default (Vue) => {
    const ImageManager = function(options = {}, selectedImgs = []) {
        const $ImageManager = Vue.extend(Manager)
        let imgManager = new $ImageManager()
        imgManager.images = JSON.parse(JSON.stringify(selectedImgs))
        imgManager.setOptions(options)
        let vm
        if (!imgManager.$el) {
          vm = imgManager.$mount()
          document.querySelector('body').appendChild(vm.$el)
        }
        $ImageManager.prototype.destroy = () => {
            if (vm) document.querySelector('body').removeChild(vm.$el)
        }
        return imgManager
    }
    return ImageManager
}



// WEBPACK FOOTER //
// ./src/components/framework/functional/image-manager.js